import React from 'react'
import { Col, Row } from 'react-bootstrap'
import LrearnImg from "../assets/banner-img-1.png"

interface Props {

}

const Learning = (props: Props) => {
    return (
        <div className='p-5 mt-3 learn_background' >
            <Row className='justify-content-center'>
                <Col md={5} className='mt-5'>
                    <h1 className="learn_text">UNLOCK YOUR CANADA DREAM LAGEXCELGLOBAL </h1>
                    <p className="learn_info">Unlock your Canadian dreams with LagExcelGlobal! 🍁✨ Secure your pathway to Permanent Residency in Canada by getting an Invitation to Apply (ITA). 🇨🇦📑 Don't miss out on this opportunity for a brighter future! 🌟 Visit   now! #CanadaPR #ITA #LagExcelGlobal </p>
                        
                    <div className="mt-2"><a href="https://forms.gle/MPjeR1hnUJ5XoC5d9" target="_blank" rel="noopener noreferrer" className="btn btn-hero1 me-5">Start Now</a></div>
                </Col>
                <Col md={5}>
                    <img src={LrearnImg} style={{ width: "100%" }} alt="" />
                </Col>
            </Row>
        </div>
    )
}

export default Learning
